import React, { ReactElement } from "react";
import { CSVLink } from "react-csv";
import { ProcessedAdsByPartnerRecord } from "../../../redux/types/reportTypes";
import { FileExcelOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const headers = [
  {
    label: "Cluster",
    key: "cluster",
  },
  {
    label: "Name",
    key: "name",
  },
  {
    label: "Period 1",
    key: "period1",
  },
  {
    label: "Period 2",
    key: "period2",
  },
  {
    label: "Difference",
    key: "difference",
  },
  {
    label: "Percentual Difference",
    key: "percentualDifference",
  },
];

type PartnerCSVProps = {
  data: Array<ProcessedAdsByPartnerRecord>;
};

const PartnerCSV = ({ data }: PartnerCSVProps): ReactElement => (
  <CSVLink data={data} headers={headers}>
    <Button type="dashed" icon={<FileExcelOutlined />} />
  </CSVLink>
);

export default PartnerCSV;
